import {TodoWrite} from '@cp/model';
import {useCallback} from 'react';
import createTodoDoc from '../../api/todo/createTodoDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useCreateTodo(uid: string | undefined) {
  const createFn = useCallback(
    (input: TodoWrite) => {
      if (!uid) throw new Error('Todo collection not found');
      return createTodoDoc(uid, input);
    },
    [uid],
  );
  const {fn, loading, error} = useFunctionWrap(createFn);

  return {
    createTodo: fn,
    loading,
    error,
  };
}
